<template>
  <v-layout
    row
    wrap
    fill-height
    class="text-xs-center align-content-center"
  >
    <v-flex xs12>
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="60"
        color="primary"
      />
    </v-flex>

    <v-card
      v-if="!loading"
      class="mx-auto align-self-center"
      color="white"
      elevation-1
      hover
      width="400"
    >
      <v-card-title>
        <h1 class="primary--text font-weight-regular mx-auto">
          Registrarse
        </h1>
      </v-card-title>

      <v-text-field
        v-model="userForm.document"
        append-icon="account_box"
        class="mx-4 uppercase"
        label="Documento"
      />

      <v-text-field
        v-model="userForm.lastName"
        class="mx-4 uppercase"
        label="Apellido"
      />

      <v-text-field
        v-model="userForm.firstName"
        class="mx-4 uppercase"
        label="Nombre"
      />

      <v-select
        v-model="userForm.sex"
        label="Sexo"
        :items="[{ value: 'M', text: 'Masculino' }, { value: 'F', text: 'Femenino' }]"
        class="mx-4"
      />

      <v-flex mx-4>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="computedDateFormatted"
              append-icon="event"
              label="Fecha de nacimiento"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            ref="picker"
            v-model="userForm.dob"
            :max="new Date().toISOString().substr(0, 10)"
            min="1900-01-01"
            locale="es"
            @change="$refs.menu.save(userForm.dob)"
          />
        </v-menu>
      </v-flex>

      <v-text-field
        v-model="userForm.email"
        append-icon="mail"
        class="mx-4"
        label="Correo Electronico"
      />

      <v-text-field
        v-model="userForm.phone"
        append-icon="smartphone"
        class="mx-4"
        label="Celular"
      />
      <span class="caption mx-4 my-0">Ejemplo: 3415880022</span>

      <v-select
        v-model="userForm.plan"
        label="Cobertura"
        :items="coberturas"
        class="mx-4"
        return-object
        item-text="nombre"
      />

      <v-card-actions>
        <v-layout
          row
          wrap
        >
          <v-flex xs11>
            <v-btn
              :disabled="!checkDisabled"
              class="primary ma-3"
              block
              @click="signUpPatient"
            >
              Registrarse
            </v-btn>
          </v-flex>
          <v-flex xs11>
            <v-btn
              class="error mb-3 ml-3"
              block
              @click="$router.replace({ name: 'LoginView' })"
            >
              Ya tienes una cuenta?
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import { registrarPaciente } from '../api/userEndpoints'
import { getCoberturas } from '../api/appointmentsEndpoints'

export default {
  name: 'SignupView',
  data () {
    return {
      menu: false,
      userForm: {
        document: null,
        firstName: null,
        lastName: null,
        sex: null,
        dob: null,
        phone: null,
        plan: null
      },
      coberturas: [],
      loading: false
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.userForm.dob)
    },
    checkDisabled () {
      return Object.values(this.userForm).every(element => element)
    }
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  async mounted () {
    this.loading = true
    this.coberturas = await getCoberturas()
    this.loading = false
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    async signUpPatient () {
      if (this.checkDisabled) {
        const newUser = { ...this.userForm }
        let prepareObject = {
          documento: newUser.document,
          nombre: newUser.firstName,
          apellido: newUser.lastName,
          sexo: newUser.sex,
          fechaNacimiento: newUser.dob.replace(/-/g, ''),
          email: newUser.email,
          celular: newUser.phone,
          obraSocial: newUser.plan.obraSocial,
          plan: newUser.plan.plan
        }
        this.loading = true
        const usuarioRegistrado = await registrarPaciente(prepareObject)
        this.loading = false
        if (usuarioRegistrado.respuesta === 'ERROR') {
          this.$createAlert({
            message: usuarioRegistrado.mensaje,
            type: 'error',
            duration: 5000
          })
        } else if (usuarioRegistrado.respuesta === 'OK') {
          this.$createAlert({
            message: usuarioRegistrado.mensaje,
            type: 'success',
            duration: 3000
          })
          this.$router.replace({ name: 'LoginView' })
        }
      }
    }
  }
}
</script>

<style lang="sass">
.progress-circle
  margin: 40vh auto

.uppercase
  input
    text-transform: uppercase !important
</style>
